/** A tyre's own page lives under the Tyres tab, `/maintenance/tyres/:id`, so the sidebar keeps Maintenance highlighted. */
export function tyrePath(id: string): string {
  return `/maintenance/tyres/${id}`;
}
